import { render, staticRenderFns } from "./ProzessFieldWrapper.vue?vue&type=template&id=663bcd60"
import script from "./ProzessFieldWrapper.vue?vue&type=script&lang=js"
export * from "./ProzessFieldWrapper.vue?vue&type=script&lang=js"
import style0 from "./ProzessFieldWrapper.vue?vue&type=style&index=0&id=663bcd60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports